import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function ProfessionalGamblingInfoContent() {
  return (
    <>
      <InfoPanelTitle>
        When is related with professional gambling?
      </InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          The IRS treats gambling as a business only when it&apos;s carried out
          regularly, with skill, and with the intent to earn income.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'IRS guidance on gambling',
              url: 'https://www.irs.gov/taxtopics/tc419',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
